import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button, Card, message } from 'antd';
import { useWriteContract } from 'wagmi';
import { CONTRACT_ADDRESS, CONTRACT_ABI } from '../config/contractConfig'; 
import DashboardLayout from '../components/DashboardLayout';

const AcceptInvite: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [projectDetails, setProjectDetails] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);

  // Extract query params
  const params = new URLSearchParams(location.search);
  const projectUrl = params.get('project');
  const invitationCode = params.get('code');

  const { writeContractAsync, isSuccess, isError, isPending } = useWriteContract(); 

  useEffect(() => {
    if (projectUrl && invitationCode) {
      // Fetch project details here using the invitation code
      // For now, use placeholders
      setProjectDetails({
        title: 'Project Title',
        description: 'Project description goes here...',
        imageUrl: 'https://via.placeholder.com/300',
        iconUrl: 'https://via.placeholder.com/50',
      });
    } else {
      // Redirect to the dashboard if query params are missing
      message.error('Invalid invite link. Redirecting to dashboard...');
      navigate('/dashboard');
    }
  }, [projectUrl, invitationCode]);

  const handleAcceptInvite = async () => {
    if (!invitationCode) {
      message.error('Invalid invitation code.');
      return;
    }

    try {
      setIsLoading(true);

      const tx = await writeContractAsync({
        address: CONTRACT_ADDRESS,
        abi: CONTRACT_ABI,
        functionName: 'acceptInvite',
        args: [invitationCode], 
      });

      if (isPending) {
        console.log('acceptInvite pending:', isPending);
      }

      if (isError) {
        console.log('acceptInvite failed:', isError);
      }

      if (isSuccess) {
        console.log('acceptInvite generated:', isSuccess);
      }

      message.success('Invitation successfully accepted!');
      navigate('/dashboard'); // Redirect to the dashboard or appropriate page
    } catch (error: any) {
      console.error('Error accepting invite:', error);
      message.error('Failed to accept the invitation. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <div style={{ padding: '2rem', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Card
          title={projectDetails ? projectDetails.title : 'Loading...'}
          bordered={false}
          style={{ width: '100%', maxWidth: '500px', textAlign: 'center' }}
        >
          {projectDetails && (
            <>
              <div style={{ backgroundColor: '#f0f2f5', padding: '1rem', marginBottom: '1rem' }}>
                <h3>Description:</h3>
                <p>{projectDetails.description}</p>
              </div>

              <h4>Project Icon:</h4>
              <img
                src={projectDetails.iconUrl}
                alt="Project Icon"
                style={{ width: '100px', height: '100px', marginTop: '10px', borderRadius: '50%' }}
              />
              <div style={{ marginTop: '20px' }}>
                <Button
                  type="primary"
                  onClick={handleAcceptInvite}
                  loading={isLoading} // Show loading state while processing
                  style={{ padding: '10px 20px' }}
                >
                  Accept Invite
                </Button>
              </div>
            </>
          )}
        </Card>
      </div>
    </DashboardLayout>
  );
};

export default AcceptInvite;
